import { Outlet } from 'react-router';
import { AppShell } from '~/components/layout/AppShell';

export function AppShellRoute() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
